import { ReactNode, useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { classNames, TranslatedString } from "@ct-react/core";
import { SkeletonableProps } from "../../tools/components";
import Button from "../common/button";
import SpriteSvg from "../common/svg";
import EquipmentResume from "../equipment/equipment-resume";
import { pricing } from "../../i18n/sharable-defs";
import { isSaleArticle, isSeasonalArticle } from "@shared/graphql";
import { defineMessages, useIntl } from "react-intl";
import { useLocaleFormatter } from "@ct-react/locale";
import PopUp from "../common/pop-up";
import { copyCurrentURL, printPage } from "../../tools/utils";
import { IconHeart } from "@tabler/icons-react";
import { card } from "../article-card";
import { useWishlist } from "../../contexts/wishlist";

import "./title.scss";

const transDefs = defineMessages({
  share: { id: "article.title.share", defaultMessage: "Partagez ce bien" },
  copy_url: { id: "article.title.copy-url", defaultMessage: "Copiez l'url" },
});

type Props = {
  title: TranslatedString;
  subTitle: ReactNode;
  url: string;
  details: any
}

const TitlePart = ({ className, loading, data }: SkeletonableProps<Props>) => {

  const intl = useIntl();
  const { print } = useLocaleFormatter();

  const [popUpOpen, setPopUpOpen] = useState<boolean>(false);
  const { has, toggle, popup } = useWishlist();

  const addToWishlist = (event: React.FormEvent<HTMLButtonElement>) => {
    event.preventDefault();
    if (!data) return;

    const res = toggle(data.details);

  };

  const wrapperClasses = classNames("title-part", className);

  if (loading || !data)
    return (
      <div className={wrapperClasses}>
        <h1><Skeleton width="65%" /></h1>
        <div className="sub-title"><Skeleton width="15rem" /></div>
        <Skeleton containerClassName="sharing"
                  count={3} inline={true} width={35} height={35} borderRadius="50%" />
      </div>);

  return (
    <div className={wrapperClasses}>
      {popup()}
      <h1>{data.title.value}</h1>
      <div className="sub-title">
        {isSaleArticle(data.details) && <span className="price">
          {data.details.price.onDemand ?
            intl.formatMessage(pricing.onDemand)
            : print.price(data.details.price.value, { trailingZeroDisplay: "stripIfInteger" }) + ".-"
        }</span>}
        {isSeasonalArticle(data.details) && <>
          <span className="price">
            {(!data.details.price || data.details.price.onDemand)
              ? intl.formatMessage(pricing.onDemand)
              : (data.details.price.isMonthly ?
                intl.formatMessage(pricing.byMonth, {
                  price: print.price(data.details.price.value, { trailingZeroDisplay: "stripIfInteger" })
                })
                : print.price(data.details.price.value, { trailingZeroDisplay: "stripIfInteger" }))
            }
          </span>
        </>}
        <EquipmentResume data={data.details}/>
      </div>
      <div className="sharing">
        <Button className="with-icon" onClick={() => setPopUpOpen(true)}><SpriteSvg id="share"/></Button>
        <Button className="with-icon" onClick={() => printPage() } ><SpriteSvg id="print"/></Button>
        <Button className={classNames("with-icon",{activ: has(data!.details.id)})} onClick={addToWishlist} ><IconHeart className="tabler"/></Button>
      </div>
      {popUpOpen && <PopUp setIsOpen={setPopUpOpen} >
        <div className="sharing-popup">
          <h3>{intl.formatMessage(transDefs.share)}</h3>
          <div>
            <a className="icone outline" href="https://www.facebook.com/verbierrentals/" target="_blank"><SpriteSvg id="facebook"/></a>
            <a className="icone outline" href={`mailto:?subject=Hey! I invite you to discover this property presented by VerbierRentals.&body=${window.location.href}`} target="_blank"><SpriteSvg id="mail-full"/></a>
            <a className="icone outline" href={`whatsapp://send?text=${encodeURIComponent(window.location.href)}`} target="_blank"><SpriteSvg id="whatsapp"/></a>
          </div>
          <p>{intl.formatMessage(transDefs.copy_url)}</p>
          <div>
            <span>{window.location.href}</span>
            <button onClick={() => copyCurrentURL()}>
              <SpriteSvg id="copy"/>
            </button>
          </div>
        </div>
      </PopUp>}
    </div>);

};

export default TitlePart;
